
<template>
  <div class="specbox">

    <ar orientation="bottomLeft"></ar>  
    <ar orientation="topRight" style="    right: -0.5px; top: -0.5px;"></ar>
    <ar orientation="bottomRight"></ar>  
    <div class="topbox">
        <ar style="left:0px;top:0px;    z-index: 1;"></ar>    
        <div class="leftbox" >
          <div class="xieline"></div>
          <div class="xiebox"></div>
          <custitle :txt="txt"/>  
        </div>
        <div class="rightbox">
           <slot name="rc"></slot>
                <div class="topline"></div>
         </div>
        
    </div>
    <custitle  :leftShow="false"/>      
    <slot></slot>
  </div>
</template>

<script>
   import DvDecoration3 from "@/components/datav/decoration3new/main"
import ar from "../arrow"
import custitle from "../custitle"
export default {
  name: 'specbox',
  props: {  
      txt: {
        type: String,
        default: "你的标题"
      }    
  },
  data () {  
    return {     
     
    }
  },
  methods: {
 
  },
  mounted () {
  
  },
  components:{
      ar,
      DvDecoration3,
      custitle
  }
}
</script>
<style lang="scss">
.specbox{
    margin-top: 40px;
    height: auto;
    width: 100%;
    position: relative;
    border: 2px solid #1D4191;
    background: rgba(76,151,230,0.06);
    display: flex;
    border-top:0px ;
    flex-direction: column;
    .title{
      display: flex;      
    }
    .topbox{
        position: absolute;
        top: -40px;
        left: -2px;
        display: flex;
        width: 100%;
        height: 40px;
        .rightbox{
          flex: 2;
          position: relative;
           .topline{
        position: absolute;
        border-top: 2px solid #1D4191;
       
        bottom: -1px;
        left: 18px;
        right: -4px;
          }
        }
        .leftbox{
          height:40px;
          position: relative;
          flex:1.6;border:2px solid #1D4191;background: rgba(76, 151, 230, 0.06);border-bottom: 0px;border-right:0px;
          .xieline{
          
         position: absolute;
       border-left: 2px solid #1D4191;

          transform: rotate(153.5deg);
          height: 45px;
          right: -10px;
          top: -4px;
          }
          
          .xiebox{
        width: 20px;
    height: 40px;
    margin: auto;
    clip-path: polygon(0 0,0 0,100% 100%,0 100%);
    position: absolute;
    right: -20px;
    top:-2px;

    background: rgba(76, 151, 230, 0.06);
          }
          
        }
        
    }
 }
 
</style>
